import BasicButton from "@components/button/BasicButton";
import { queryClient } from "@libs/reactQuery/queryClient";
import useOrderIdStore from "@store/order/useOrderIdStore";
import useOrderStore from "@store/order/useOrderStore";
import { useMutation } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import React from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  paymentData: any; // 결제 데이터
  onPaymentStart: (data: any) => Promise<{ order_id: string }>; // 결제 시작 핸들러
  children: React.ReactNode;
};

const BankTransferButton = ({
  paymentData,
  onPaymentStart,
  children,
}: Props) => {
  const { updateOrder, deleteCart } = useApiRequest();
  const navigate = useNavigate();
  const lang = window.localStorage.getItem("language");
  const { clearOrder, cartIds } = useOrderStore();
  const { clearOrderId } = useOrderIdStore();
  const method = "B";

  // 장바구니 아이템 삭제
  const { mutate: deleteMutate } = useMutation({
    mutationFn: deleteCart,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["cartList"] }),
  });

  // 결제수단 업데이트
  const { mutate } = useMutation({
    mutationFn: ({
      id,
      payment,
      lang,
    }: {
      id: number;
      payment: any;
      lang: any;
    }) => updateOrder(id, payment, lang),
    onSuccess: () => {
      navigate(`/success?method=${method}`);

      clearOrder(); // 주문 데이터 삭제
      clearOrderId(); // 주문ID 삭제
      deleteMutate(cartIds); // 결제 승인 성공 시 장바구니 아이템 삭제
    },
  });

  const handlePayment = async () => {
    // 결제 수단업데이트
    const { order_id } = await onPaymentStart(paymentData);

    mutate({
      id: Number(order_id),
      payment: "B",
      lang,
    });
  };

  return (
    <BasicButton
      title=""
      width="33.5rem"
      height="5.2rem"
      onClick={handlePayment}>
      {children}
    </BasicButton>
  );
};

export default BankTransferButton;
